import { auth_request, request } from "./request";
import { apiBaseUrl as baseUrl } from "./apiBaseUrl";
import http from "./http";
import { sortBranchesPutTestLast } from "@helpers/sortBranchesPutTestLast";
const invoice_baseUrl = "https://api.ezreceipt.cc";
const try_invoice_baseUrl = "https://tryapi.ezreceipt.cc";

function authHeaders(token) {
  return { Authorization: "Bearer " + token };
}

function withSignal(config, options = {}) {
  const nextConfig = { ...config };
  if (options?.signal) {
    nextConfig.signal = options.signal;
  }
  if (options?.params) {
    nextConfig.params = options.params;
  }
  return nextConfig;
}

// 註冊
function signUp(username, password) {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrl + `adminUsers/v2/register`, {
        username: username,
        password: password,
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 驗證信箱帳號
function verifyEmailToken(token, email) {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrl + `adminUsers/validateEmailToken`, {
        emailToken: token,
        email: email,
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 登入取得 token
function login(username, password) {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrl + "adminUsers/login", {
        username: username,
        password: password,
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 取得活動資料
function getEventRegions(token, branchId) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `adminUsers/getEventRegions`, {
        params: {
          branchId: branchId,
        },
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 取得特定活動資料
function getSelectedEvent(token, branchId, eventId, date) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `adminUsers/getEventRegions`, {
        params: {
          branchId: branchId,
          date: date,
          eventId: eventId,
        },
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
/**
 * 拿 brandId 換 Branches List
 *
 * @description 收據列印開啟時會呼叫此 API 取得分店與 settings
 * @returns {Object} res.data.data[0].branches[] 包含：
 *   - branch_name / branch_address / phone / person_in_charge
 *   - settings.company_seal_url      大小章
 *   - settings.receipt_stamp_url      收據章
 *   - settings.is_detailed_display   是否明細
 *   - settings.summary_description   療程內容／統一顯示名稱
 *
 * @see PopPrintReceipt.js - 收據列印元件
 */
function getFindBranches(token, brandId) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `adminUsers/branches/${brandId}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        const brand = response?.data?.data?.[0];
        if (brand?.branches) {
          brand.branches = sortBranchesPutTestLast(brand.branches);
        }
        resolve(response);
      })
      .catch((err) => reject(err));
  });
}
// 拿 branchId 取得 Events
function getBranchEvents(token, branchId) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `adminUsers/events/${branchId}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 取得現場入場名單
function getRedeemHistory(token, eventId) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `adminUsers/redeemHistory`, {
        params: {
          eventId: eventId,
        },
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 取得酒水票資料
function getGiftTicketsInfo(token, branchId) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `adminUsers/getGiftTicketsInfo/${branchId}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 取得銷售資料
function getSalesInfo(token, branchId) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `adminUsers/getSalesInfo/${branchId}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// 取得銷售資料
function getPassTicketsInfo(token, branchId) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `adminUsers/getPassTicketsInfo/${branchId}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// 更新品牌
function UpdateBrand(token, brandId, data) {
  return auth_request(
    "put",
    baseUrl,
    `adminUsers/updateBrand/${brandId}`,
    token,
    data
  );
  // return new Promise((resolve, reject) => {
  //   http
  //     .put(baseUrl + `adminUsers/updateBrand/${brandId}`, data, {
  //       headers: {
  //         Authorization: "Bearer " + token,
  //       },
  //     })
  //     .then((response) => resolve(response))
  //     .catch((err) => reject(err));
  // });
}

//  ======================= 發票相關 =============================
function getInvoiceToken() {
  return new Promise((resolve, reject) => {
    http
      .post(
        invoice_baseUrl + "/admin/user/login",
        {
          accName: "U91075649",
          passwd: "f0a7abfb7e063124f197f5f1af6c2fd52392855e",
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-deva-locale": "zh",
            "x-deva-appcode": "91075649",
            "x-deva-appkey": "fe539db45d75abab90ac2d6c936d6845",
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

function queryInvoices(token, selectedDate) {
  // console.log(selectedDate)
  return new Promise((resolve, reject) => {
    http
      .post(
        invoice_baseUrl + "/eInvoice/invoice/list",
        {
          fromTime: selectedDate.start,
          toTime: selectedDate.end,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-deva-locale": "zh",
            "x-deva-appcode": "91075649",
            "x-deva-appkey": "fe539db45d75abab90ac2d6c936d6845",
            "x-deva-token": token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

function voidInvoice(token, reason, invID) {
  return new Promise((resolve, reject) => {
    http
      .post(
        invoice_baseUrl + `/eInvoice/invoice/void/${invID}`,
        {
          voidReason: reason,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-deva-locale": "zh",
            "x-deva-appcode": "91075649",
            "x-deva-appkey": "fe539db45d75abab90ac2d6c936d6845",
            "x-deva-token": token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 後端發票取消
function cancelInvoice(token, invNo) {
  return new Promise((resolve, reject) => {
    http
      .delete(baseUrl + "bill/cancelInvoice", {
        data: {
          invNo: invNo,
        },
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// ------- 發票相關[測試用] -------
function tryGetInvoiceToken() {
  return new Promise((resolve, reject) => {
    http
      .post(
        try_invoice_baseUrl + "/admin/user/login",
        {
          accName: "U91075649",
          passwd: "9c5911b10abc838081ae301dcc6ac50ce7fa77a0",
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-deva-locale": "zh",
            "x-deva-appcode": "91075649",
            "x-deva-appkey": "2ec06188ef092f468deffcb9103759e3",
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

function tryQueryInvoices(token, selectedDate) {
  // console.log(selectedDate)
  return new Promise((resolve, reject) => {
    http
      .post(
        try_invoice_baseUrl + "/eInvoice/invoice/list",
        {
          fromTime: selectedDate.start,
          toTime: selectedDate.end,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-deva-locale": "zh",
            "x-deva-appcode": "91075649",
            "x-deva-appkey": "2ec06188ef092f468deffcb9103759e3",
            "x-deva-token": token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

function tryVoidInvoice(token, reason, invID) {
  return new Promise((resolve, reject) => {
    http
      .post(
        try_invoice_baseUrl + `/eInvoice/invoice/void/${invID}`,
        {
          voidReason: reason,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-deva-locale": "zh",
            "x-deva-appcode": "91075649",
            "x-deva-appkey": "2ec06188ef092f468deffcb9103759e3",
            "x-deva-token": token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// 掃描入場
function scanByTicket(token, branchId, productId, code) {
  return new Promise((resolve, reject) => {
    http
      .post(
        baseUrl + "redeem/scanByBrand",
        {
          branchId: branchId,
          productId: productId,
          QRcode: code,
          note: "test",
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 現金購票
function cashBuyTicket(token, branchId, productId, address, price) {
  return new Promise((resolve, reject) => {
    http
      .post(
        baseUrl + "adminUsers/createTicketToAddress",
        {
          branchId: Number(branchId),
          brandProductId: Number(productId),
          QRcode: address,
          price: Number(price),
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 取得當天購票人員資料
function onsitePurchase(token, branchId) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `adminUsers/onsitePurchase/${branchId}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 電話登入會員並取得持有票券
function getUserTickets(token, phone) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `adminUsers/userTickets`, {
        params: {
          phone: phone,
        },
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 購買活動票券 現場購票 + 現場預約
function buyTicketToAddress(token, data) {
  return new Promise((resolve, reject) => {
    http
      .post(
        baseUrl + "adminUsers/createEventTicketToAddress",
        {
          phone: data.phone,
          QRcode: data.QRcode,
          eventId: data.eventId,
          branchId: data.branchId,
          regionId: data.regionId,
          ticketList: data.ticketList,
          eventDate: data.eventDate,
          eventName: data.eventName,
          regionName: data.regionName,
          pricing: data.pricing,
          totalPrice: data.totalPrice,
          timeDescription: data.timeDescription,
          startTime: data.startTime,
          endTime: data.endTime,
          paymentMethod: data.paymentMethod,
          paymentMessage: data.paymentMessage,
          adminUserId: data.adminUserId,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 核銷活動票券 現場購票 + 現場預約
function redeemTicketToAddress(token, data) {
  return new Promise((resolve, reject) => {
    http
      .post(
        baseUrl + "redeem/adminRedeemTicketByQRCode",
        {
          eventId: data.eventId,
          slotId: data.slotId,
          QRcode: data.QRcode,
          note: data.note,
          ticketType: data.ticketType,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 掃描 QRcode 核銷票券
function redeemTicketByScan(token, data) {
  return new Promise((resolve, reject) => {
    http
      .post(
        baseUrl + "redeem/adminRedeemTicketByQRCode",
        {
          eventId: data.eventId,
          QRcode: data.QRcode,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 取得 商家的所有商品
function getBranchProducts(token, branchId) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `adminUsers/branchProduct`, {
        params: {
          branchId: branchId,
        },
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 取得 商家的所有訂單狀態
function paymentsByBranch(token, branchId) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `adminUsers/payments`, {
        params: {
          branchId: branchId,
        },
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 取得 售票員名單
function getAdminBranchUsers(token, branchId) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `adminUsers/branchUsers`, {
        params: {
          branchId: branchId,
        },
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 取得 預約訂單
function getAdminReservations(token, branchId) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `adminUsers/reservations`, {
        params: {
          branchId: branchId,
        },
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 取得分店顧客
function getMembers(token, branchId) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `adminUsers/getMember?branchId=${branchId}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 取得分店產品
function getProducts(token, branchId) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `adminUsers/products?brandId=${branchId}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
} // 取得報名列表
function getEvents(token, brandId) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `adminUsers/events/?brandId=${brandId}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 取得預約訂單
function getReservations(token, branchId) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `adminUsers/reservations`, {
        params: {
          branchId: branchId,
        },
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 取得分店服務
function GetServicesbyBranchID(token, branchId, options = {}) {
  return new Promise((resolve, reject) => {
    http
      .get(
        baseUrl + `adminReservation/service/${branchId}`,
        withSignal(
          {
            params: {
              branchId: branchId,
            },
            headers: {
              Authorization: "Bearer " + token,
            },
          },
          options
        )
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 新增分店服務
function AddService(token, data) {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrl + `adminReservation/service`, data, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 刪除分店服務
function DeleteService(token, serviceId) {
  return new Promise((resolve, reject) => {
    http
      .delete(baseUrl + `adminReservation/service/${serviceId}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};








function newDeleteService(token, serviceId) {
  return new Promise((resolve, reject) => {
    http
      .delete(baseUrl + `services/${serviceId}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

function newGetAllService(token, serviceId) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `services/share/branchId/${serviceId}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

function newGetAllServiceV2(token, serviceId) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `services/v2/branchId/${serviceId}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};














// 修改分店服務
function UpdateService(token, data, serviceId) {
  return new Promise((resolve, reject) => {
    http
      .put(baseUrl + `adminReservation/service/${serviceId}`, data, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 取得分店人員
function GetEmployeesbyBranchID(token, branchId, options = {}) {
  return new Promise((resolve, reject) => {
    http
      .get(
        baseUrl + `adminReservation/employees/${branchId}`,
        withSignal(
          {
            params: {
              branchId: branchId,
            },
            headers: {
              Authorization: "Bearer " + token,
            },
          },
          options
        )
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 檢查分店人員帳號是否重複
function usernameDuplicate(token, data) {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrl + `adminReservation/usernameDuplicate`, data, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// 新增分店人員
function AddEmployee(token, data) {
  return new Promise((resolve, reject) => {
    // console.log('API Request Data:', data); // 記錄發送的資料

    http
      .post(baseUrl + `adminReservation/employee`, data, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        // console.log('API Response:', response); // 記錄 API 回應
        if (response.data.status === "success") {
          resolve(response);
        } else {
          const failMsg =
            response.data.msg || response.data.message || "新增失敗";
          console.log("[AddEmployee] AddEmployee failed", failMsg);
          reject(new Error(failMsg));
        }
      })
      .catch((err) => {
        console.log("API Error:", err.response || err); // 記錄詳細錯誤
        reject(err);
      });
  });
}
// 刪除分店人員
function DeleteEmployee(token, branchId, employeeId, adminUsersId) {
  return new Promise((resolve, reject) => {
    http
      .delete(
        baseUrl +
        `adminReservation/employee/${branchId}/${employeeId}/${adminUsersId}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// 修改分店人員
function UpdateEmployee(token, data, employeeId) {
  return new Promise((resolve, reject) => {
    http
      .put(baseUrl + `adminReservation/employee/${employeeId}`, data, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// 店員帳號封存
function addEmployeeIsArchived(token, branchId, adminUsersId, employeeId) {
  return new Promise((resolve, reject) => {
    http
      .patch(
        baseUrl + `adminReservation/addEmployeeIsArchived/${adminUsersId}`,
        {
          branchId,
          employeeId,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// 店員帳號解除封存
function delEmployeeIsArchived(token, branchId, adminUsersId, employeeId) {
  return new Promise((resolve, reject) => {
    http
      .patch(
        baseUrl + `adminReservation/delEmployeeIsArchived/${adminUsersId}`,
        {
          branchId,
          employeeId,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// 取得班別
function GetShiftsByBranchID(token, branchId, options = {}) {
  return new Promise((resolve, reject) => {
    http
      .get(
        baseUrl + `adminReservation/shifts/${branchId}`,
        withSignal(
          {
            params: {
              branchId: branchId,
            },
            headers: {
              Authorization: "Bearer " + token,
            },
          },
          options
        )
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 取得班表
function GetEmployeeShiftsByBranchID(token, branchId, options = {}) {
  return new Promise((resolve, reject) => {
    http
      .get(
        baseUrl + `adminReservation/employeeShifts/${branchId}`,
        withSignal(
          {
            params: {
              branchId: branchId,
            },
            headers: {
              Authorization: "Bearer " + token,
            },
          },
          options
        )
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 新增班表(單筆)
function AddEmployeeShift(token, data) {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrl + `adminReservation/employeeShifts`, data, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// 新增/刪除班表
function addOrdDeleteEmployeeShift(token, data) {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrl + `adminReservation/addOrdDeleteEmployeeShift`, data, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// 刪除班別(目前無地方新增)
function DeleteEmployeeShift(token, params) {
  return new Promise((resolve, reject) => {
    http
      .delete(baseUrl + `adminReservation/employeeShifts/${params}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 修改班表(單筆)
function UpdateEmployeeShift(token, branchId) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `adminReservation/employeeShift/${branchId}`, {
        params: {
          branchId: branchId,
        },
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 新增班別
function AddShift(token, data) {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrl + `adminReservation/shift`, data, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 刪除班別
function DeleteShift(token, shiftId) {
  return new Promise((resolve, reject) => {
    http
      .delete(baseUrl + `adminReservation/shift/${shiftId}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 修改班別
function UpdateShift(token, data, shiftId) {
  return new Promise((resolve, reject) => {
    http
      .put(baseUrl + `adminReservation/shift/${shiftId}`, data, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 取得預約訂單(新)
function GetAppointments(token, branchId, options = {}) {
  return new Promise((resolve, reject) => {
    http
      .get(
        baseUrl + `adminReservation/appointmentsWithDoctorOrder/${branchId}`,
        withSignal(
          {
            headers: {
              Authorization: "Bearer " + token,
            },
          },
          options
        )
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

function GetChangeLogs(token, appointmentId) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `appointments/changeLogs/${appointmentId}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 取得會員課程資料
function getMemberCheckoutPackage(token, userId) {
  return new Promise((resolve, reject) => {
    http
      .get(`${baseUrl}packageServices/v3/ticket/${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (response.data.status === "success") {
          resolve(response.data.data); // 返回票券資料
        } else {
          reject("取得課程資料失敗");
        }
      })
      .catch((err) => {
        console.log("[getMemberCheckoutPackage] getMemberCheckoutPackage failed", err);
        reject(err);
      });
  });
}

// 新增預約
function AddAppointment(token, data) {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrl + `adminReservation/appointments`, data, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 取得分店會員（醫美還需要branch name)
function GETBrandMembers(token, brandId, options = {}) {
  return new Promise((resolve, reject) => {
    http
      .get(
        baseUrl + `adminReservation/members/${brandId}`,
        withSignal(
          {
            headers: {
              Authorization: "Bearer " + token,
            },
          },
          options
        )
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

/** 依病歷號 (origin_id) 取得指定分店中單一會員 */
function getMemberByOriginId(token, brandId, originId) {
  return new Promise((resolve, reject) => {
    http
      .get(
        baseUrl + `adminReservation/members/${brandId}/origin/${encodeURIComponent(originId)}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

/** 依 userId 取得指定分店中單一會員 */
function getMemberByUserId(token, brandId, userId) {
  return new Promise((resolve, reject) => {
    http
      .get(
        baseUrl + `adminReservation/members/${brandId}/user/${encodeURIComponent(userId)}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 取得分店會員
function GETUserByPhone(token, phone) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `adminReservation/users/${phone}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 新增會員
function CreateMemberUser(token, data) {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrl + `adminReservation/createMemberUser`, data, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
function startTapPay(token, data) {
  // const ngrok = 'https://2761-123-192-149-167.ngrok-free.app/'

  return new Promise((resolve, reject) => {
    http
      .post(`${baseUrl}pay/startTapPay`, data, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

function startTapPayCard(
  token,
  prime,
  id,
  brandName,
  planType,
  method = "create",
  holder
) {
  const ngrok =
    "https://e40e-2407-4d00-3c00-8197-adcd-6a3f-d2fa-d929.ngrok-free.app/";
  return new Promise((resolve, reject) => {
    http
      .post(
        // `${ngrok}pay/startTapPayCard`,
        `${baseUrl}pay/startTapPayCard`,
        {
          prime: prime,
          brand_id: id,
          brand_name: brandName,
          planType: planType,
          method: method,
          holder_name: holder.name,
          holder_phone: holder.phone,
          holder_email: holder.email,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
function updateTapPayCard(token, prime, id, brandName, planType, method) {
  const ngrok =
    "https://e40e-2407-4d00-3c00-8197-adcd-6a3f-d2fa-d929.ngrok-free.app/";
  return new Promise((resolve, reject) => {
    http
      .post(
        `${baseUrl}pay/updateTapPayCard`,
        {
          prime: prime,
          brand_id: id,
          brand_name: brandName,
          planType: null,
          method: method,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 刪除預約
function DeleteAppointment(token, appointmentId) {
  return new Promise((resolve, reject) => {
    http
      .delete(baseUrl + `adminReservation/appointment/${appointmentId}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 更改預約資訊
function UpdateAppointmentStatus(token, appointmentId, status) {
  return new Promise((resolve, reject) => {
    http
      .patch(
        baseUrl + `adminReservation/appointment/${appointmentId}`,
        status,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 更改預約狀態
function UpdateAppointment(token, data) {
  return new Promise((resolve, reject) => {
    http
      .put(baseUrl + `adminReservation/appointment/update`, data, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 新增預約細項(已付款後)
function Checkout(token, data) {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrl + `adminReservation/checkout`, data, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 取得預約細項
function GetBilling(token, queryString) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `adminReservation/billingWithDoctorOrder?${queryString}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 修改分店會員
function updateMemberUser(token, data) {
  return new Promise((resolve, reject) => {
    http
      .put(baseUrl + `adminReservation/updateMemberUser`, data, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// 取得 卡片資訊
function getBrandCardInfo(id, token) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `pay/getBrandCardInfo/${id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 手機查詢是否為品牌會員
function getisBrandMember(token, data) {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrl + `adminReservation/getUserisBrandMember`, data, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// 手機查詢是否為分店會員
function checkUserInBranch(token, data) {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrl + `adminReservation/checkUserInBranch`, data, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// 自動化訊息預約設定
// 取得提醒設定種類
function fetchAllReminderTypes(token) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `adminUsers/reminderTypes`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => reject(err));
  });
}

// 取得提醒設定狀態
function getRemindersByBranchId(token, branchId) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `adminUsers/reminders/${branchId}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => reject(err));
  });
}

// 更改提醒設定狀態
function reminderSetting(
  token,
  branchId,
  reminderTypeId,
  sendViaSms,
  sendViaEmail,
  sendViaLineBot,
  messageContent,
  lineContent,
  isActive,
  advanceTime
) {
  return new Promise((resolve, reject) => {
    http
      .patch(
        baseUrl + `adminUsers/reminders/${branchId}/${reminderTypeId}`,
        {
          sendViaSms,
          sendViaEmail,
          sendViaLineBot,
          messageContent,
          lineContent,
          isActive,
          advanceTime,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 啟用方案
function createBrandPlan(token, BrandId, planType) {
  return new Promise((resolve, reject) => {
    http
      .post(
        baseUrl + `adminReservation/checkout`,
        {
          brand_id: BrandId,
          plan_type: planType,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
function verifyReferralCode(token, BrandId, code) {
  return new Promise((resolve, reject) => {
    http
      .post(
        baseUrl + `pay/verifyReferralCode`,
        {
          brand_id: BrandId,
          code: code,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 刪除會員
function deleteMemberUser(token, data) {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrl + `adminReservation/deleteMemberUser`, data, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 新增黑名單
function addMemberUserIsBlacklisted(token, data) {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrl + `adminReservation/addMemberUserIsBlacklisted`, data, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 移除黑名單
function delMemberUserIsBlacklisted(token, data) {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrl + `adminReservation/delMemberUserIsBlacklisted`, data, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// 上傳店員圖片
function UploadEmployeeAvatar(token, data) {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrl + `s3/upload/employees/avatarUrl`, data, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// Brand 啟用方案
function startBrandPlan(token, data) {
  return new Promise((resolve, reject) => {
    http
      .post(
        baseUrl + `subscribe/startBrandPlan`,
        {
          brandId: data.brandId,
          subscribeRuleName: data.subscribeRuleName,
          referralCode: data.referralCode,
          toBInvoice: data.toBInvoice,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// 訂閱相關
function getSubscribeBrandInfo(token, brandId) {
  return new Promise((resolve, reject) => {
    http
      .post(
        baseUrl + `subscribe/getSubscribeBrandInfo`,
        {
          brandId: brandId,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// 訂閱相關
function cancelBrandPlan(token, brandId, cancelReason) {
  return new Promise((resolve, reject) => {
    http
      .delete(baseUrl + `subscribe/cancelBrandPlan`, {
        data: {
          brandId: brandId,
          cancelReason: cancelReason,
        },
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// 更新分店資訊
function updateBranch(token, branchId, data) {
  return new Promise((resolve, reject) => {
    http
      .patch(baseUrl + `adminUsers/updateBranch/${branchId}`, data, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// 將檔案上傳 s3 轉成 url (by Brand)
function convertFileToUrlByBrand(token, file) {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append("file", file);
    http
      .post(baseUrl + `s3/upload/brands/brandLogoUrl`, formData, {
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// 將檔案上傳 s3 轉成 url (by Brand Image)
function convertFileToUrlByBrandImage(token, file) {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append("file", file);
    http
      .post(baseUrl + `s3/upload/brands/brandImageUrl`, formData, {
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// 將檔案上傳 s3 轉成 url (by Branch)
function convertFileToUrl(token, file) {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append("file", file);
    http
      .post(baseUrl + `s3/upload/branches/branchLogoUrl`, formData, {
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 將檔案 list 上傳 s3 轉成 url list
function convertArrayToUrlList(token, files) {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append("file", files);
    http
      .post(baseUrl + `s3/upload/branches/branchImages`, formData, {
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 創建品牌
function createBrand(token, data) {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrl + `adminUsers/addBrand`, data, {
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 創建分店
function createBranch(token, data) {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrl + `adminUsers/createBranch`, data, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 上下架分店
function deactivateBranch(token, branchId, boolean) {
  return new Promise((resolve, reject) => {
    http
      .post(
        baseUrl + `subscribe/deactivateBranch`,
        {
          branch_id: branchId,
          frontend_display: boolean,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// 刪除分店
function deleteBranch(token, branchId) {
  return new Promise((resolve, reject) => {
    http
      .post(
        baseUrl + `subscribe/deleteBranch`,
        {
          branch_id: branchId,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// 分店訂閱
function activateBranch(token, branchId) {
  return new Promise((resolve, reject) => {
    http
      .post(
        baseUrl + `adminUsers/activateBranch`,
        {
          branch_id: branchId,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

function getAllPlans(token) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `subscribe/getAllPlans`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => reject(err));
  });
}

function updateBrandPlan(token, data) {
  return new Promise((resolve, reject) => {
    http
      .post(
        baseUrl + `subscribe/updateBrandPlan`,
        {
          brandId: data.brandId,
          subscribeRuleId: data.subscribeRuleId,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

function getSubscribeBill(token, bId) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `pay/getSubscribeBill/${bId}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => reject(err));
  });
}
function cancelBranchSubscribe(token, data) {
  return new Promise((resolve, reject) => {
    http
      .post(
        baseUrl + `subscribe/cancelBranchSubscribe`,
        {
          brand_id: data.brand_id,
          branch_id: data.branch_id,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
function subscribeUnexpiredBranchAgain(token, data) {
  return new Promise((resolve, reject) => {
    http
      .post(
        baseUrl + `subscribe/subscribeUnexpiredBranchAgain`,
        {
          brandId: data.brand_id,
          branchId: data.branch_id,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

function updateBrandInvoice(token, data) {
  return new Promise((resolve, reject) => {
    http
      .patch(
        baseUrl + `adminUsers/updateBrandInvoice`,
        {
          brandId: data.brandId,
          invoice: data.invoice,
          companyLetterhead: data.companyLetterhead,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

function getInvoiceSetting(token, brandId) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `adminUsers/getInvoiceSetting/${brandId}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => reject(err));
  });
}

function resendVerifyEmail(email) {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrl + `adminUsers/resendVerificationEmail`, {
        email: email,
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// ---------- brand member level ----------

// CHARLENE
// get Brand member Level settings
function getBrandMemberLevelSettings(token, brandId) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `adminUsers/levels?brandId=${brandId}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => reject(err));
  });
}

// CHARLENE
// Create Brand Member Level
function createMemberLevelByMemberLevelId(
  token,
  enabledReward,
  brandId,
  level,
  levelName,
  levelAvatar,
  cumulativeAmount,
  pointsPerCumulation,
  upgradeCondition,
  renewedCondition,
  benefits
) {
  return new Promise((resolve, reject) => {
    http
      .post(
        baseUrl + `adminUsers/levels`,
        {
          enabledReward,
          brandId,
          level,
          levelName,
          levelAvatar,
          cumulativeAmount,
          pointsPerCumulation,
          upgradeCondition,
          renewedCondition,
          benefits,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// CHARLENE
// Update Brand Member Level
function updateMemberLevelByMemberLevelId(token, memberLevelId, updates) {
  return new Promise((resolve, reject) => {
    http
      .put(baseUrl + `adminUsers/levels/${memberLevelId}`, updates, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// CHARLENE
// toggle Brand Member level activation
function toggleBrandMemberLevelActivation(token, brandId, activate) {
  return new Promise((resolve, reject) => {
    http
      .put(
        baseUrl + `adminUsers/toggleBrandMemberLevel`,
        {
          brandId: brandId,
          activate: activate,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// ---------- discounts and vouchers ----------

// CHARLENE
// read discount by BRAND id
function readDiscountByBrandId(token, brandId) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `adminUsers/discount/brand/${brandId}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => reject(err));
  });
}

// CHARLENE
// update discount by id not brand id
function updateDiscountById(
  token,
  id,
  brandId,
  category,
  discountType,
  amount,
  expiredType,
  duringDays,
  start,
  end,
  content,
  ruleDescription,
  logo,
  discountImage,
  isActivated,
  discountName,
  getVouchersRequirePoints,
  isAutoDiscount,
  voucherReason
) {
  return new Promise((resolve, reject) => {
    http
      .put(
        baseUrl + `adminUsers/discount/${id}`,
        {
          brandId,
          category,
          discountType,
          amount,
          expiredType,
          duringDays,
          start,
          end,
          content,
          ruleDescription,
          logo,
          discountImage,
          isActivated,
          discountName,
          getVouchersRequirePoints,
          isAutoDiscount,
          voucherReason,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// CHARLENE
// update isActivated in discount by id
function updateDiscountActivateById(token, id, data) {
  return new Promise((resolve, reject) => {
    http
      .patch(baseUrl + `adminUsers/discount/${id}`, data, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// CHARLENE
// create discount by id
function createDiscountById(
  token,
  brandId,
  category,
  discountType,
  amount,
  expiredType,
  duringDays,
  start,
  end,
  content,
  ruleDescription,
  logo,
  discountImage,
  isActivated,
  discountName,
  voucherReason,
  getVouchersRequirePoints
) {
  return new Promise((resolve, reject) => {
    http
      .post(
        baseUrl + `adminUsers/discount`,
        {
          brandId,
          category,
          discountType,
          amount,
          expiredType,
          duringDays,
          start,
          end,
          content,
          ruleDescription,
          logo,
          discountImage,
          isActivated,
          discountName,
          voucherReason,
          getVouchersRequirePoints,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// CHARLENE
// delete discount by id
function deleteDiscountById(token, id) {
  return new Promise((resolve, reject) => {
    http
      .delete(baseUrl + `adminUsers/discount/${id}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// ---------- brand points settings ----------
// CHARLENE
// get brand points settings
function getBrandPointsSettings(token) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `adminUsers/getPointSetting`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => reject(err));
  });
}

// CHARLENE
// toggle note display for points setting
function toggleNoteDisplayForPointsSetting(token, noteDisplay) {
  return new Promise((resolve, reject) => {
    http
      .patch(
        baseUrl + `adminUsers/updatePointNoteDisplay`,
        {
          noteDisplay,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// CHARLENE
// update note for points setting
function updateNoteForPointsSetting(token, note) {
  return new Promise((resolve, reject) => {
    http
      .patch(
        baseUrl + `adminUsers/updatePointNote`,
        {
          note,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// ---------- balance settings ----------
// CHARLENE
// get brand balance settings
function getBalanceSettings(token) {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `adminUsers/getBalanceSetting`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => reject(err));
  });
}

// CHARLENE
// toggle note display for balance setting
function toggleNoteDisplayForBalanceSetting(token, noteDisplay) {
  return new Promise((resolve, reject) => {
    http
      .patch(
        baseUrl + `adminUsers/updateBalanceSettingNote`,
        {
          noteDisplay,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// CHARLENE
// update note for balance setting
function updateNoteForBalanceSetting(token, note) {
  return new Promise((resolve, reject) => {
    http
      .patch(
        baseUrl + `adminUsers/updateBalanceSettingNote`,
        {
          note,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

// 取得所有預約
function getAppointmentsFromHelper(branchId, token) {
  return request(
    "get",
    baseUrl,
    `appointments/v2/appointments/${branchId}?jobTitle=doctor`,
    token
  );
}

// 修改使用者密碼
function updateAdminUserPassword(token, data) {
  return request(
    "patch",
    baseUrl,
    `adminUsers/admin-user-password`,
    token,
    data
  );
}

// 取得員工業績 (含 appointments, packages)
function getEmployeePerformanceByBranchID(token, branchId, startAt, endAt) {
  // startAt, endAt 都是可選參數，沒帶就不傳
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + `employeePerformance/byBranch/${branchId}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
        params: {
          // 若沒傳就不帶參數，預設當日
          ...(startAt && { startAt }),
          ...(endAt && { endAt }),
        },
      })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        } else {
          reject({
            status: "error",
            message: `Unexpected status code: ${response.status}`,
          });
        }
      })
      .catch((err) => reject(err));
  });
};

function getEmployeeByBranchId(token, branchId) {
  return request("get", baseUrl, `employees/job-titles/branches/${branchId}`, token);
};


export {
  activateBranch,
  AddAppointment,
  AddEmployee,
  addEmployeeIsArchived,
  AddEmployeeShift,
  addMemberUserIsBlacklisted,
  addOrdDeleteEmployeeShift,
  AddService,
  AddShift,
  buyTicketToAddress,
  cancelBranchSubscribe,
  // subscribeBranchAgain,
  cancelBrandPlan,
  cancelInvoice,
  cashBuyTicket,
  Checkout,
  checkUserInBranch,
  convertArrayToUrlList,
  convertFileToUrl,
  convertFileToUrlByBrand,
  convertFileToUrlByBrandImage,
  createBranch,
  createBrand,
  createDiscountById,
  createMemberLevelByMemberLevelId,
  CreateMemberUser,
  deactivateBranch,
  delEmployeeIsArchived,
  DeleteAppointment,
  deleteBranch,
  deleteDiscountById,
  DeleteEmployee,
  DeleteEmployeeShift,
  deleteMemberUser,
  DeleteService,



  newDeleteService,
  newGetAllService,
  newGetAllServiceV2,



  DeleteShift,
  delMemberUserIsBlacklisted,
  fetchAllReminderTypes,
  getAdminBranchUsers,
  getAdminReservations,
  getAllPlans,
  GetAppointments,
  GetChangeLogs,
  // helper
  getAppointmentsFromHelper,
  // balance
  getBalanceSettings,
  GetBilling,
  getBranchEvents,
  getBranchProducts,
  getBrandCardInfo,
  // member level
  getBrandMemberLevelSettings,
  GETBrandMembers,
  getMemberByOriginId,
  getMemberByUserId,
  // point
  getBrandPointsSettings,
  // 取得訂單業績明細
  getEmployeePerformanceByBranchID,
  GetEmployeesbyBranchID,
  GetEmployeeShiftsByBranchID,
  getEventRegions,
  getEvents,
  getFindBranches,
  getGiftTicketsInfo,
  getInvoiceSetting,
  getInvoiceToken,
  // membership
  getisBrandMember,
  getMemberCheckoutPackage,
  getMembers,
  getPassTicketsInfo,
  getProducts,
  getRedeemHistory,
  getRemindersByBranchId,
  getReservations,
  getSalesInfo,
  getSelectedEvent,
  GetServicesbyBranchID,
  GetShiftsByBranchID,
  getSubscribeBill,
  getSubscribeBrandInfo,
  GETUserByPhone,
  getUserTickets,
  login,
  onsitePurchase,
  paymentsByBranch,
  queryInvoices,
  // discount
  readDiscountByBrandId,
  redeemTicketByScan,
  redeemTicketToAddress,
  reminderSetting,
  resendVerifyEmail,
  scanByTicket,
  signUp,
  // subscribe
  startBrandPlan,
  startTapPay,
  startTapPayCard,
  subscribeUnexpiredBranchAgain,
  toggleBrandMemberLevelActivation,
  toggleNoteDisplayForBalanceSetting,
  toggleNoteDisplayForPointsSetting,
  tryGetInvoiceToken,
  tryQueryInvoices,
  tryVoidInvoice,
  // 修改使用者密碼
  updateAdminUserPassword,
  UpdateAppointment,
  UpdateAppointmentStatus,
  updateBranch,
  UpdateBrand,
  // invoice setting
  updateBrandInvoice,
  updateBrandPlan,
  updateDiscountActivateById,
  updateDiscountById,
  UpdateEmployee,
  updateMemberLevelByMemberLevelId,
  updateMemberUser,
  updateNoteForBalanceSetting,
  updateNoteForPointsSetting,
  UpdateService,
  UpdateShift,
  updateTapPayCard,
  UploadEmployeeAvatar,
  usernameDuplicate,
  verifyEmailToken,
  verifyReferralCode,
  voidInvoice,


  getEmployeeByBranchId
};
